import * as React from 'react'
import * as Moment from 'moment'
import { IQuestionnaireComment } from '../../../Model/Questionnaire'

export interface IQuestionnaireCommentViewProps {
    className?: string
    comment: IQuestionnaireComment
}

export default class QuestionnaireCommentView extends React.Component<IQuestionnaireCommentViewProps> {
    render() {
        const { comment } = this.props

        return (
            <div className={this.props.className}>
                <p className="addDate">{Moment(comment.createDate!.toString()).format('DD.MM.YYYY')}</p>
                <p className="userName">{comment.userName}</p>
                <p className="commentText">{comment.content}</p>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Questionnaire/QuestionnaireCommentView.tsx